export class UserLogoutRequestDto {
  /** The current role id the user is logging out as */
  currentRoleId: number;
  /** The session UID for identifying the session */
  sessionUid: string;
  /** The access token (ignored for serialization in some cases) */
  accessToken?: string;
   // Constructor with parameters to initialize properties
   constructor(currentRole: number, sessionUid: string, accessToken?: string) {
    this.currentRoleId = currentRole;
    this.sessionUid = sessionUid;
    this.accessToken = accessToken;
  }
}